import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=ff057a96&"
import script from "./MainComponent.vue?vue&type=script&lang=js&"
export * from "./MainComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainComponent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports